// Grupos de agencias (holdings) por país
// Fuente única de verdad para IDs de agencias por holding

export const GRUPOS_AGENCIAS = {
  Chile: [
    { nombre: "DENTSU", ids: [31, 35] },
    { nombre: "HAVAS", ids: [29, 90] },
    { nombre: "IPG", ids: [88, 84, 81, 51, 72, 82] },
    { nombre: "OMNICOM", ids: [110, 79, 85, 111, 28] },
    { nombre: "PUBLICIS", ids: [33, 73, 37] },
    { nombre: "WPP", ids: [34, 67, 89] },
  ],
  Perú: [
    { nombre: "DENTSU", ids: [48] }, // CARAT
    { nombre: "HAVAS", ids: [2] },
    { nombre: "IPG", ids: [47, 74, 44, 86] }, // INITIATIVE, MEDIAHUB, THRIVE, UM
    { nombre: "OMNICOM", ids: [45, 43, 23] }, // MA, OMD, PHD
    { nombre: "PUBLICIS", ids: [7] },
    { nombre: "WPP", ids: [52, 75, 105] }, // MINDSHARE, WAVEMAKER, WPP
  ],
};

// Helper para obtener grupos por país
export const getGruposAgencias = (pais) => GRUPOS_AGENCIAS[pais] || [];

// Helper para verificar si un ID de agencia pertenece a un grupo
export const getGrupoByAgenciaId = (agenciaId, pais) => {
  const grupos = getGruposAgencias(pais);
  return grupos.find((grupo) => grupo.ids.includes(agenciaId));
};
